import '.hc{margin:auto 4px;}.ssr-plugin'
import '.hd{height:calc(100% - 8px );}.ssr-plugin'
import '.he{width:1px;}.ssr-plugin'
import '.hf{z-index:0;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.hg{padding:2px 8px 2px 8px;}.ssr-plugin'
import '.hh{height:5px;}.ssr-plugin'
import '.ad{height:1px;}.ssr-plugin'
import '.hi{width:2px;}.ssr-plugin'
import '.hj{height:2px;}.ssr-plugin'
import '.hk{margin:auto 8px;}.ssr-plugin'
import '.go{display:inline-block;}.ssr-plugin'
import '.e4{border-radius:4px;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { Style, styled } from 'inlines'

type SeparatorProps = {
  orientation?: 'horizontal' | 'vertical'
  variant?: 'line' | 'dot'
  style?: Style
}

function Separator({
  orientation = 'horizontal',
  variant = 'line',
  style,
}: SeparatorProps) {
  if (variant === 'line') {
    if (orientation === 'vertical') {
      return (
        <styled.div className="hc hd he hf"
          style={{
            background: colors.neutral10,
            ...style,
          }}
        />
      )
    }
    return (
      <styled.div className="f hg hh"
        style={{
          ...style,
        }}
      >
        <div className="ad f"
          style={{ background: colors.neutral10 }}
        />
      </styled.div>
    )
  } else {
    return (
      <styled.div className="hi hj hk go e4 hf"
        style={{
          background: colors.neutral60,
          // margin:'auto 6px',
          ...style,
        }}
      />
    )
  }
}

export { Separator }
export type { SeparatorProps }
